module.exports = __webpack_public_path__ + "img/logoOrientestProV.3d6687c3.svg";